import {Component, Input} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {TrendingCutPage} from '../../pages/trending-cut/trending-cut';
import {HttpClient} from '@angular/common/http';
import {ApiErrorHandlerProvider} from '../../providers/api-error-handler/api-error-handler';

/**
 * Generated class for the ShopCutsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'shop-cuts',
    templateUrl: 'shop-cuts.html',
})
export class ShopCutsComponent {
    @Input() shop: any;
    errors: {};
    loading: boolean;
    // Setup empty array of objects to have placeholders on page load
    trendingCuts: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
    ) {
        this.shop = navParams.get('shop');
    }

    ngOnInit() {
        this.getTrendingCuts();
    }

    getTrendingCuts() {
        this.loading = true;

        this.http.get(`/teams/${this.shop.id}/trending-cuts`).subscribe(
            (trendingCuts) => {
                this.trendingCuts = trendingCuts;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            },
            () => {
            },
        );
    }

    openPage(event: any, trendingCut: object) {
        this.navCtrl.push(TrendingCutPage, {
            trendingCuts: this.trendingCuts,
            trendingCut: trendingCut,
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/shop-cuts/shop-cuts.ts